import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card, Row, Col, Statistic, Progress, Button, Space, Typography,
  Input, Select
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// ────────────────────────────────────────────
//  Mock 数据 — TODO: 联调时替换为接口数据
// ────────────────────────────────────────────

const MOCK_CLUSTERS = [
  { key: 'huabei', name: '华北集群', count: 12350, color: '#1677ff' },
  { key: 'huadong', name: '华东集群', count: 8920, color: '#52c41a' },
  { key: 'huanan', name: '华南集群', count: 6780, color: '#fa8c16' },
  { key: 'north-am', name: '北美集群', count: 3450, color: '#722ed1' },
  { key: 'europe', name: '欧洲集群', count: 2100, color: '#eb2f96' },
  { key: 'asia-pac', name: '亚太集群', count: 1820, color: '#13c2c2' },
];

const TOTAL_DEVICES = MOCK_CLUSTERS.reduce((sum, c) => sum + c.count, 0);

const MOCK_STATS = {
  licenseTotal: 50000,
  deviceTotal: TOTAL_DEVICES,
  produced: 35420,
  bound: 21200,
  online: 5430,
};

// ══════════════════════════════════════════════
//  主组件
// ══════════════════════════════════════════════

const DeviceStatistics = () => {
  const navigate = useNavigate();
  const [searchType, setSearchType] = useState('license');
  const [searchKeyword, setSearchKeyword] = useState('');

  // ── 查询设备 → 跳转设备详情页 ──
  const handleSearch = () => {
    if (!searchKeyword.trim()) return;
    const param = searchType === 'license' ? `license=${searchKeyword}` : `did=${searchKeyword}`;
    navigate(`/device/info?${param}`);
  };

  return (
    <div style={{ padding: 24 }}>
      <Title level={4}>设备统计</Title>

      {/* 设备总量统计 */}
      <Card bordered={false} style={{ marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <div style={{ display: 'flex', gap: 16 }}>
          <div style={{ flex: 1, textAlign: 'center', padding: '12px 0' }}>
            <Statistic title="License总数" value={MOCK_STATS.licenseTotal} />
          </div>
          <div style={{ flex: 1, textAlign: 'center', padding: '12px 0' }}>
            <Statistic title="设备总数" value={MOCK_STATS.deviceTotal} />
          </div>
          <div style={{ flex: 1, textAlign: 'center', padding: '12px 0' }}>
            <Statistic title="已绑定" value={MOCK_STATS.bound} />
            <div style={{ marginTop: 4 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>绑定率</Text>
              <Progress percent={Math.round((MOCK_STATS.bound / MOCK_STATS.produced) * 100)} size="small" style={{ maxWidth: 100, margin: '0 auto' }} />
            </div>
          </div>
          <div style={{ flex: 1, textAlign: 'center', padding: '12px 0' }}>
            <Statistic title="昨日在线" value={MOCK_STATS.online} valueStyle={{ color: '#52c41a' }} />
          </div>
        </div>
      </Card>

      {/* 集群设备分布 */}
      <Card
        title="集群设备分布"
        bordered={false}
        style={{ marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}
      >
        <Row gutter={[16, 16]}>
          {MOCK_CLUSTERS.map((c) => (
            <Col key={c.key} xs={24} sm={12} md={8} lg={4}>
              <Card
                bordered={false}
                style={{
                  borderRadius: 10,
                  background: '#fafafa',
                  textAlign: 'center',
                }}
                bodyStyle={{ padding: '20px 16px' }}
              >
                <Text type="secondary" style={{ fontSize: 13 }}>{c.name}</Text>
                <div style={{ fontSize: 28, fontWeight: 600, margin: '8px 0', color: c.color }}>
                  {c.count.toLocaleString()}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                  <Progress
                    percent={TOTAL_DEVICES > 0 ? Math.round((c.count / TOTAL_DEVICES) * 100) : 0}
                    showInfo={false}
                    size="small"
                    strokeColor={c.color}
                    style={{ flex: 1, maxWidth: 120, margin: 0 }}
                  />
                  <Text type="secondary" style={{ fontSize: 11 }}>
                    {TOTAL_DEVICES > 0 ? Math.round((c.count / TOTAL_DEVICES) * 100) : 0}%
                  </Text>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>

      {/* 设备查询 */}
      <Card
        title="设备查询"
        bordered={false}
        style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}
      >
        <Space size={8}>
          <Select value={searchType} onChange={setSearchType} style={{ width: 110 }}>
            <Select.Option value="license">License</Select.Option>
            <Select.Option value="did">设备ID</Select.Option>
          </Select>
          <Input
            placeholder={searchType === 'license' ? '请输入 License' : '请输入设备ID'}
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            style={{ width: 280 }}
            allowClear
            onPressEnter={handleSearch}
          />
          <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
        </Space>
        <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>
          输入 nodata 可查看未找到设备交互，输入其他值展示设备详情
        </Text>
      </Card>
    </div>
  );
};

export default DeviceStatistics;
